import React, { Fragment } from "react";
import Label from "./Label";

const TextArea = passedProps => {
  const { name, required, label, value, maxLength, ...props } = passedProps;
  let { rows } = passedProps;
  if (!rows) {
    rows = 5;
  }

  const currentLength = value?.length || 0;
  const showCounter = maxLength !== undefined;
  const remainingChars = maxLength ? maxLength - currentLength : 0;
  const isNearLimit = maxLength && currentLength > maxLength * 0.8;

  const getCounterClass = () => {
    if (isNearLimit) {
      return "text-warning";
    }
    return "text-muted";
  };

  return (
    <Fragment>
      <Label htmlFor={name} required={required}>
        {label}
      </Label>
      <textarea 
        name={name} 
        id={name} 
        className="form-control" 
        rows={rows} 
        value={value}
        maxLength={maxLength}
        {...props} 
      />
      {showCounter && (
        <small className={getCounterClass()}>
          {currentLength} / {maxLength} characters used
          {isNearLimit && ` (${remainingChars} remaining)`}
        </small>
      )}
    </Fragment>
  );
};

export default TextArea;
